import { useEffect, useState } from "react";
import { getCurrentCacheUser } from "../apis/cache.api";
const useCurrentUserCache = () => {
  const [currentUserCache, setCurrentUserCache] = useState(null);

  useEffect(() => {
    // call api get current cache from server
    getCurrentCacheUser((result) => {
      if (result) {
        setCurrentUserCache(result);
      } else {
        setCurrentUserCache(null);
      }
    });
  }, []);

  return { currentUserCache, setCurrentUserCache };
};

export default useCurrentUserCache;
